import { ThemeProvider } from './context'
import ThemeRoutes from './routes/Routes'

// Flaticons
import './../node_modules/@flaticon/flaticon-uicons/css/all/all.css'

// Theme.scss
import './assets/scss/theme.scss'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Suspense } from 'react'
import { Preloader } from './components/lib/molecules/Preloader'

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <Suspense fallback={<Preloader />}>
          <ThemeRoutes />
        </Suspense>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

export default App
